import { render, staticRenderFns } from "./LsActionButton.vue?vue&type=template&id=3a164c40&scoped=true&"
import script from "./LsActionButton.vue?vue&type=script&lang=js&"
export * from "./LsActionButton.vue?vue&type=script&lang=js&"
import style0 from "./LsActionButton.vue?vue&type=style&index=0&id=3a164c40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a164c40",
  null
  
)

export default component.exports